export const SKIN_CARE_CATEGORY = "soins-peau";

export const SKIN_CARE_LIGHTENING_PRODUCTS = [
  "Caro White",
  "Paw Paw",
  "Idole",
  "CT+",
  "Caro Light",
  "Lili",
  "Prima",
  "Turmeric",
  "Carotone",
];

export const SKIN_CARE_SUBCATEGORIES = [
  {
    value: "cremes-eclaircissantes",
    label: "Crèmes éclaircissantes",
    description: `Caro White, Paw Paw, Idole, CT+, Caro Light, Lili, Prima, Turmeric et Carotone.`,
  },
  {
    value: "savons",
    label: "Savons",
    description: "Savons pour le visage et le corps.",
  },
  {
    value: "huiles-corporelles",
    label: "Huiles corporelles",
    description: "Huiles destinées aux soins de la peau.",
  },
];

export const PRODUCT_CATEGORY_OPTIONS = [
  { value: "soin", label: "Soin cheveux" },
  { value: "barbe", label: "Barbe" },
  { value: "coiffage", label: "Coiffage" },
  { value: "accessoire", label: "Accessoire" },
  { value: "cadeau", label: "Coffret cadeau" },
  {
    value: SKIN_CARE_CATEGORY,
    label: "Soins de la peau",
    subcategories: SKIN_CARE_SUBCATEGORIES,
  },
];

export const getProductCategoryLabel = (value) => {
  const option = PRODUCT_CATEGORY_OPTIONS.find((category) => category.value === value);
  if (option) return option.label;

  return String(value || "")
    .replace(/[-_]+/g, " ")
    .trim()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const getProductSubcategoryOptions = (categoryValue) => (
  PRODUCT_CATEGORY_OPTIONS.find((category) => category.value === categoryValue)?.subcategories || []
);

export const getProductSubcategoryLabel = (value) => {
  const option = SKIN_CARE_SUBCATEGORIES.find((subcategory) => subcategory.value === value);
  return option ? option.label : getProductCategoryLabel(value);
};
